import { render, staticRenderFns } from "./LUpload.vue?vue&type=template&id=3965aa28&"
import script from "./LUpload.vue?vue&type=script&lang=js&"
export * from "./LUpload.vue?vue&type=script&lang=js&"
import style0 from "./LUpload.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3965aa28')) {
      api.createRecord('3965aa28', component.options)
    } else {
      api.reload('3965aa28', component.options)
    }
    module.hot.accept("./LUpload.vue?vue&type=template&id=3965aa28&", function () {
      api.rerender('3965aa28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/jeecg/LUpload.vue"
export default component.exports